/* import __COLOCATED_TEMPLATE__ from './select-workspace-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();